// extracted by mini-css-extract-plugin
export default {"App":"pages_App__--I0t","Loader":"pages_Loader__5vKuN","Notification":"pages_Notification__5TczN"};